
import Vue from "vue";
import AddFamilyComponent from "@/components/family/AddFamilyComponent.vue";
import AddSourceComponent from "@/components/source/AddSourceComponent.vue";
import AddMoleculeComponent from "@/components/molecule/AddMoleculeComponent.vue";
import AddSynergyComponent from "@/components/synergy/AddSynergyComponent.vue";

export default Vue.extend({
  name: "AddView",
  components: {
    AddFamilyComponent,
    AddSourceComponent,
    AddMoleculeComponent,
    AddSynergyComponent,
  },
  props: {
    mode: String,
    update: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
});
